export default "__VITE_ASSET__0C8T9KeQ__"